<script>
export default {
  functional: true,
  props: {
    topIndent: { type: Boolean, default: false }
  },
  render(h, ctx) {
    const fullClassList = ['section']
    if (ctx.props.topIndent) {
      fullClassList.push('section--top-indent')
    }

    return h(
      'div',
      {
        ...ctx.data,
        class: fullClassList
      },
      ctx.children
    )
  }
}
</script>
